(function (angular) {
    'use strict';

    // alternate session implementation
    var SessionManager = (function () {
        function SessionManager($timeout, $state, $uibModal, $location) {
            this.$timeout = $timeout;
            this.$state = $state;
            this.$uibModal = $uibModal;
            this.$location = $location;
        }
        Object.defineProperty(SessionManager.prototype, "sessionInfo", {
            get: function () {

                var jwt = sessionStorage.getItem("jwt");
                if (jwt) {
                    var bits = jwt.split(".");
                    if (bits.length === 3) {
                        var header = JSON.parse(atob(bits[0]));
                        var payload = JSON.parse(atob(bits[1]));
                        var signature = bits[2];

                        var sessionInfo = {
                            session: {
                                createdOn: new Date(payload.iat * 1000).toISOString(),
                                // deviceId: "2ED8EA5F-19B8-45AA-9CD1-32C517B1553B",
                                expiresOn: new Date(payload.exp * 1000).toISOString(),
                                // id: "A78B9D3A-B9B4-4612-BE8A-4221A198DD62",
                                isActive: true,
                                platform: "Web",
                                // platformVersion: "1.2.3",
                                profileId: "PLATFORMUSER\\" + payload.sub,
                                // sdkType: "SDK",
                                // sdkVersion: "1.2.3",
                                // sourceIp: "127.0.0.1",
                            },
                            token: jwt,
                        };

                        return sessionInfo;

                    } else {
                        return null;
                    }
                } else {
                    return null;
                }
            },
            enumerable: true,
            configurable: true
        });

        SessionManager.prototype.getValidToken = function () {
            var sessionInfo = this.sessionInfo;
            return Promise.resolve(sessionInfo ? sessionInfo.token : null);
        };
        SessionManager.prototype.startSession = function () {
            var self = this;
            if (!this.isExpired()) {
                return Promise.resolve(this.sessionInfo);
            } else {
                return this.relogin()
                    .then(function () {
                        return Promise.resolve(self.sessionInfo);
                    })
                    .catch(function () {
                        self.$timeout(function () {
                            self.$state.go('login', { "link": self.$location.path() });
                        });
                        return Promise.reject({ message: "User Cancelled out of login" });
                    })
            }
        };
        SessionManager.prototype.endSession = function () { return Promise.resolve(true); };
        // just do the same as start ....
        SessionManager.prototype.ensureSession = function () { return this.startSession(); };


        SessionManager.prototype.initialise = function () { return Promise.resolve(true); }

        SessionManager.prototype.isExpired = function () {
            var sessionInfo = this.sessionInfo;
            if (sessionInfo) {
                var expiry = new Date(sessionInfo.session.expiresOn);
                var now = new Date();
                return expiry < now;
            }
            else {
                return true;
            }
        }

        SessionManager.prototype.relogin = function () {

            var modal = this.$uibModal.open({
                templateUrl: 'shared/login/relogin.html',
                controller: 'ReLoginController',
                size: 'sm',
                backdrop: 'static',
                keyboard: false
            });

            return modal.result;
        }

        return SessionManager;
    }());


    angular.module('shared')
        .factory('SessionManager', ["$timeout", "$state", "$uibModal", "$location", function ($timeout, $state, $uibModal, $location) {

            var sessionManager = new SessionManager($timeout, $state, $uibModal, $location);
            return sessionManager;
        }]);

})(window.angular);
